'use client';

import type { PageConfigType } from '@/types';
import FinalCTA from '@/components/marketing/FinalCTA';
import HeroSection from '@/components/marketing/HeroSection';
import MarketingDomains from '@/components/marketing/MarketingDomains';
import MarketingQuestionCard from '@/components/marketing/MarketingQuestionCard';
import Reviews from '@/components/marketing/Reviews';
import Stats from '@/components/marketing/Stats';
import WhyChooseUs from '@/components/marketing/WhyChooseUs';
import { Container, Divider } from '@mui/material';
import FaqList from './FAQsSection';
const MarketingPage = ({
  config
}: {
  config: PageConfigType;
}) => {
  const reviews = config?.reviews || [];
  const faqs = config?.faqs || [];
  return <Container maxWidth="lg" sx={{
    py: {
      xs: 0
    }
  }} data-sentry-element="Container" data-sentry-component="MarketingPage" data-sentry-source-file="MarketingPage.tsx">
      <HeroSection config={config} data-sentry-element="HeroSection" data-sentry-source-file="MarketingPage.tsx" />
      {/* Divider */}
      {config.statsBlock ? <Divider sx={{
      my: {
        xs: 4,
        md: 8
      }
    }} /> : null}
      {config.statsBlock ? <Stats statsObj={config.statsBlock} /> : null}
      {/* Divider */}
      <Divider sx={{
      my: {
        xs: 4,
        md: 8
      }
    }} data-sentry-element="Divider" data-sentry-source-file="MarketingPage.tsx" />
      {/* Why Choose Us */}
      <WhyChooseUs data-sentry-element="WhyChooseUs" data-sentry-source-file="MarketingPage.tsx" />
      {reviews ? <Divider sx={{
      my: {
        xs: 4,
        md: 8
      }
    }} /> : null}
      {/* Reviews */}
      {reviews ? <Reviews reviews={reviews} /> : null}

      <Divider sx={{
      my: {
        xs: 4,
        md: 8
      }
    }} data-sentry-element="Divider" data-sentry-source-file="MarketingPage.tsx" />
      <MarketingQuestionCard question={config.practiceQuestion} data-sentry-element="MarketingQuestionCard" data-sentry-source-file="MarketingPage.tsx" />
      <Divider sx={{
      my: {
        xs: 4,
        md: 8
      }
    }} data-sentry-element="Divider" data-sentry-source-file="MarketingPage.tsx" />
      {/* Domain Breakdown */}
      <MarketingDomains productId={config.productId} data-sentry-element="MarketingDomains" data-sentry-source-file="MarketingPage.tsx" />
      {/* Final CTA */}
      {faqs ? <Divider sx={{
      my: {
        xs: 4,
        md: 8
      }
    }} /> : null}
      {/* Reviews */}
      {faqs ? <FaqList faqs={faqs} /> : null}
      <FinalCTA config={config} data-sentry-element="FinalCTA" data-sentry-source-file="MarketingPage.tsx" />
    </Container>;
};
export default MarketingPage;